import './index.scss'
import _ from 'lodash'
import Swiper from 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'
import 'particles.js'
import './verdor.js'
import '../../assets/scripts/swiper-bundle.min.js'



$(document).ready(function () {
  // getScrollXH()
});
window.onload = function () {
  bannerSwiper()
}

function bannerSwiper() {
  let $bannerPaginationEl = $('.index-banner-pagination .list');
  let swiper = new Swiper('.banner-swiper', {
    spaceBetween: 30,
    effect: 'fade',
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    pagination: {
      el: $bannerPaginationEl,
      clickable: true,
      bulletClass: 'asdasdasdasd',
      bulletActiveClass: 'active',
      modifierClass: 'askdjwkdjdk',
      renderBullet: function (index, className) {
        return `
                  <div class="item ${ className }" style="animation-duration: ${ this.passedParams.autoplay.delay }ms">
                  <div class="dian"></div>
                  </div>
              `;
      }
    },
    on: {
      slideChange: function () {
        let ind = this.activeIndex+1
        $('.swiper-numpagun .indexswiper').html('0'+ind)
      },
      init: function () {
        let indall = this.slides.length
        $('.swiper-numpagun .indexnumall').html('0'+indall)
      }
    }
  })
}

// 首页产品
var swiperpro = new Swiper('.sec4_swiper_content', {
  slidesPerView: 1.5,
  spaceBetween: 20,
  navigation: {
      nextEl: '.swiper-btn .pre',
      prevEl: '.swiper-btn .next',
      disabledClass: 'disabled',
  },
  breakpoints: {
    768: {
      slidesPerView: 3.1,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3.1,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4.1,
      spaceBetween: 30,
    },
    1620: {
      slidesPerView: 4.1,
      spaceBetween: 20,
    },
  }
});
// 20230613结束

//获取pc端产品区域高度
// function getScrollXH() {
//   if(document.body.clientWidth > 992){
//     let xscrollH = $('.xscroll .x').outerWidth() - $('.xscroll-cont').width() + $(window).height() 

//     console.log('高度xscrollH',xscrollH)
//     console.log('内容x宽度',$('.xscroll .x').outerWidth());
//     console.log('内容cont宽度',$('.xscroll-cont').width());
//     console.log('浏览器高度',$(window).height());
//     $('.xscroll').css('height', xscrollH)

//   }
// }